import { ISingleWayPointConfig } from './singleWayPoint/ISingleWayPointConfig';
import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer';
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer';


export class IrisrawModSingleWayPoint extends IrisModContainer<IrisConfigContainer<ISingleWayPointConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModSingleWayPoint.createIrisrawModSingleWayPointConfig)        
    }

    static createIrisrawModSingleWayPoint(datas:IIrisModContainerConstParam) {        
        return new IrisrawModSingleWayPoint(datas)
    }

    static createIrisrawModSingleWayPointConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<ISingleWayPointConfig>(data)
    }

}